export enum GENERAL_ASSETS {
  WHITE_CIRCLE = 'WHITE_CIRCLE',
}

export const TRANSPARENT_COLOR = '#ffffff00'

export const STANDARD_NUMBER_WIDTH = 48
export const STANDARD_NUMBER_HEIGHT = 48

export const LARGE_NUMBER_WIDTH = 144
export const LARGE_NUMBER_HEIGHT = 144

export const STANDARD_LARGE_NUMBER_RATIO = STANDARD_NUMBER_HEIGHT / LARGE_NUMBER_HEIGHT


export type AudioKeyTemplate = {
  BIG_WIN: string
  BONUS_CHOSEN: string
  BONUS_ELIMINATED: string
  MATCH: string
  NO_BONUS: string
  NO_MATCH: string
  SMALL_WIN: string
}
